import { z } from "zod";

/** The PIN stays a string: a number would turn "0123" into 123 and fail with a raw error code. */
export const otpSchema = z.object({
	otp: z.string().regex(/^\d{4}$/, { message: "pin-format" }),
});

export type OtpType = z.infer<typeof otpSchema>;
